<script>
import { Line, mixins } from 'vue-chartjs'
import ChartJsPluginDataLabels from 'chartjs-plugin-datalabels'
import _cloneDeep from 'lodash/cloneDeep'

const { reactiveProp } = mixins

export default {
  extends: Line,
  mixins: [reactiveProp],

  name: 'RevenueAndProfitLineChart',

  props: {
    chartData: {
      type: Object,
      default: () => ({})
    },
    titleChart: {
      type: String,
      default: ''
    }
  },

  watch: {
    titleChart: {
      handler (newOption, oldOption) {
        let options = _cloneDeep(this.options)
        options.title.text = newOption
        this.$data._chart.destroy()
        this.renderChart(this.chartData, options)
      },
      deep: true
    },
    chartData: {
      handler () {
        const HTML = this.$data._chart.generateLegend()
        this.$emit('generated-legend', HTML)
      },
      deep: true
    }
  },

  components: { ChartJsPluginDataLabels },

  data () {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false,
          onClick () {
            return null
          }
        },
        layout: {
          padding: {
            top: 20,
            right: 50
          }
        },
        title: {
          display: true,
          position: 'left',
          fontColor: '#B9B9C3',
          text: this.titleChart
        },
        scales: {
          title: {
            color: 'red'
          },
          xAxes: [
            {
              ticks: {
                fontColor: '#B9B9C3',
                fontSize: 12
              },
              gridLines: {
                drawOnChartArea: false
              }
            }
          ],
          yAxes: [
            {
              ticks: {
                fontColor: '#B9B9C3',
                fontSize: 12,
                callback: (val) => {
                  return this.$util.shortManNumber(val)
                }
              },
              gridLines: {
                drawOnChartArea: true
              }
            }
          ]
        },
        plugins: {
          datalabels: {
            font: {
              size: 10
            },
            formatter: (val) => {
              return this.$util.numberSymbolFormatter(val)
            },
            color: '#6e6b7b',
            align: (val) => {
              return val.dataset.label === '今期' ? 'top' : val.dataset.label === '前期' ? 'left' : 'right'
            },
            anchor: 'end',
            offset: (val) => {
              return val.dataset.label === '今期' ? 0 : 2
            },
            clamp: false
          }
        },
        legendCallback: function (chart) {
          const { datasets } = chart.data
          const legendHtml = datasets.map(
            (dataset) =>
              `<div class="legend-item">
                <div class="legend-item__line" style="background-color: ${dataset.borderColor}"></div>
                <span class="legend-item__label">${dataset.year}</span>
              </div>`
          )

          return legendHtml.join('')
        }
      }
    }
  },

  mounted () {
    this.addPlugin(ChartJsPluginDataLabels)
    this.renderChart(this.chartData, this.options)
    const HTML = this.$data._chart.generateLegend()
    this.$emit('generated-legend', HTML)
  }
}
</script>
